// removed by extract-text-webpack-plugin
module.exports = {"header":"_1dcLFzap20puFTgvj2OQzG","inner":"_1yiMRrElA9ch3UKnbliw-l","filters":"leBvTHmjrXz0OfO9ZCwbl","list-outer":"_21CX84KUT3y-QiVGe_-crg","list":"_3soKewEN5DOeAOat-Ww7WD","searching":"_2h1I_4ZpsIV3SDMoZUGSNI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureArticlesFilter/FeatureArticlesFilter.module.scss
// module id = 757
// module chunks = 0